import gql from 'graphql-tag'

import { AppUnregisterDataQuery } from '../../../types/api'

export const unregisterData = {
  query: gql`
    query AppUnregisterData($token: String!) {
      peUnregisterData(token: $token) {
        id
        email
        event {
          name
          locales {
            label
            iso
          }
          translations {
            translation {
              name
            }
            locale {
              iso
            }
          }
        }
        slot {
          closing_hour
          opening_hour
        }
      }
    }
  `,
  transformer: (response: AppUnregisterDataQuery) => {
    return response.peUnregisterData
  },
}
